module.exports = __webpack_public_path__ + "img/symbol_11.401cee38.png";